/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slimy_Front_Crossbill_DineInputs */

const fr_slimy_front_crossbill_dine = /** @type {(inputs: Slimy_Front_Crossbill_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

/**

* @param {Slimy_Front_Crossbill_DineInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const slimy_front_crossbill_dine = /** @type {((inputs?: Slimy_Front_Crossbill_DineInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slimy_Front_Crossbill_DineInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_slimy_front_crossbill_dine(inputs)
});